import React from 'react';
import { Link } from 'react-router-dom';
import config from '../utils/config';

function PrivacyPolicy() {
  const lastUpdated = new Date('2026-10-12').toLocaleDateString();

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#0a0b0d', 
      color: '#e4e4e7',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none',
              marginBottom: '16px',
              display: 'inline-block'
            }}
          >
            ← Back to Home
          </Link>
          
          <h1 style={{ 
            fontSize: '32px', 
            fontWeight: 'bold', 
            marginBottom: '8px',
            color: '#ffffff'
          }}>
            Privacy Policy
          </h1>
          
          <p style={{ color: '#9ca3af', fontSize: '14px' }}>
            Last updated: {lastUpdated}
          </p>
        </div>

        {/* Content */}
        <div style={{ 
          backgroundColor: '#12141a', 
          border: '1px solid #1f232e',
          borderRadius: '8px',
          padding: '32px',
          lineHeight: '1.6'
        }}>
          
          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            1. Information We Collect
          </h2>
          
          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Files and Content
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Files you upload to our service</li>
            <li>File metadata (name, size, type, upload date)</li>
            <li>Folder names and organization</li>
            <li>Expiry settings you choose for your files</li>
          </ul>

          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Technical Information
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>IP address and general location</li>
            <li>Browser type and version</li>
            <li>Device information</li>
            <li>Upload and download timestamps</li>
            <li>Error logs and performance metrics</li>
          </ul>

          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Cookies and Tracking
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>User session identifiers (stored locally)</li>
            <li>Analytics data and identifiers used by Google Analytics and Microsoft Clarity</li>
            <li>Performance and error tracking data</li>
          </ul>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            2. How We Use Your Information
          </h2>
          
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li><strong>File Storage:</strong> To store and serve your uploaded files</li>
            <li><strong>Service Operation:</strong> To provide file sharing and download functionality</li>
            <li><strong>Security:</strong> To prevent abuse and protect against malicious uploads</li>
            <li><strong>Analytics:</strong> Google Analytics and Microsoft Clarity help us understand site usage and interaction patterns so we can improve our service</li>
            <li><strong>Technical Support:</strong> To diagnose and fix technical issues</li>
          </ul>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            3. Data Storage and Security
          </h2>
          
          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            File Storage
          </h3>
          <ul style={{ marginBottom: '16px', paddingLeft: '20px', color: '#d1d5db' }}>
                              <li>Files are stored on our secure storage infrastructure</li>
                  <li>Metadata is stored in our secure database</li>
            <li>All data is encrypted in transit and at rest</li>
            <li>Files are automatically deleted after the expiry period you choose (1, 3, 5, or 7 days)</li>
          </ul>

          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Security Measures
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>HTTPS encryption for all data transmission</li>
            <li>Rate limiting to prevent abuse</li>
            <li>Regular security audits and updates</li>
            <li>No personal information required for service use</li>
          </ul>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            4. Data Sharing and Third Parties
          </h2>
          
          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Service Providers
          </h3>
          <ul style={{ marginBottom: '16px', paddingLeft: '20px', color: '#d1d5db' }}>
                              <li><strong>Infrastructure Partners:</strong> Secure content delivery and storage</li>
            <li><strong>Google Analytics:</strong> Site usage analytics</li>
            <li><strong>Microsoft Clarity:</strong> Site usage and interaction analytics</li>
          </ul>

          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Legal Requirements
          </h3>
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            We may disclose information if required by law, such as to comply with a subpoena or similar legal process, or to protect our rights and the safety of our users.
          </p>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            5. Your Rights and Choices
          </h2>
          
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li><strong>File Control:</strong> You can delete your files at any time</li>
            <li><strong>Expiry Settings:</strong> You control how long files are stored (1, 3, 5, or 7 days)</li>
            <li><strong>Anonymous Use:</strong> No account registration required</li>
            <li><strong>Data Export:</strong> You can download your files at any time</li>
          </ul>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            6. Data Retention
          </h2>
          
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Files are automatically deleted after the expiry period you choose</li>
            <li>Metadata is deleted when files are deleted</li>
            <li>Log data is retained for up to 30 days for security purposes</li>
            <li>Anonymous analytics data may be retained longer for service improvement</li>
          </ul>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            7. Children's Privacy
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.
          </p>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            8. International Data Transfers
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            Your data may be transferred to and processed in countries other than your own. We ensure that such transfers comply with applicable data protection laws and that your data receives adequate protection.
          </p>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            9. Changes to This Policy
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "last updated" date.
          </p>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            10. Contact Us
          </h2>
          
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            If you have any questions about this Privacy Policy, please contact us:
          </p>
          
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Email: {config.contactEmail}</li>
            <li>Through our <Link to="/contact" style={{ color: '#3b82f6', textDecoration: 'none' }}>contact form</Link></li>
          </ul>

          <h2 style={{ color: '#3b82f6', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            11. Content Removal
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            We reserve the right to remove or delete any files or content that violate copyright laws, contain illegal material, or are reported as harmful. This helps us maintain a safe and legal environment for all users.
          </p>

        </div>

        {/* Footer Navigation */}
        <div className="mt-8 text-center">
          <Link 
            to="/contact"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none',
              marginRight: '24px'
            }}
          >
            Contact Us
          </Link>
          
          <Link 
            to="/terms-of-service"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none',
              marginRight: '24px'
            }}
          >
            Terms of Service
          </Link>
          
          <Link 
            to="/"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none'
            }}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy; 
